import { useState } from 'react'

import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'
import { getTrackingConsent, setTrackingConsent } from '@/lib/tracking-client'

export function CookieConsent(): ReactElement | null {
  const [decided, setDecided] = useState(() => getTrackingConsent() !== null)

  if (decided) return null

  function decide(granted: boolean) {
    setTrackingConsent(granted)
    setDecided(true)
  }

  return (
    <div
      role="dialog"
      aria-label="Consentimento de cookies"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-gold/[0.22] bg-[rgba(0,15,24,0.94)] px-5 py-4 backdrop-blur-[12px] sm:px-8"
    >
      <div className="mx-auto flex max-w-[1180px] flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-[#D9D3C8]">
          Usamos cookies para entender como você navega e melhorar sua experiência. Você pode
          aceitar ou recusar o rastreamento.
        </p>
        <div className="flex flex-shrink-0 gap-3">
          <Button
            type="button"
            variant="outline"
            className="min-h-[44px] flex-1 sm:flex-none"
            onClick={() => decide(false)}
          >
            Recusar
          </Button>
          <Button
            type="button"
            className="min-h-[44px] flex-1 sm:flex-none"
            onClick={() => decide(true)}
          >
            Aceitar
          </Button>
        </div>
      </div>
    </div>
  )
}
